import { render, staticRenderFns } from "./UmanjeniSatCreate.vue?vue&type=template&id=446fec0e&scoped=true&"
import script from "./UmanjeniSatCreate.vue?vue&type=script&lang=js&"
export * from "./UmanjeniSatCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446fec0e",
  null
  
)

export default component.exports